import React from 'react';
import Container from '@mui/material/Container';
import DemoComponent from "../components/demo/DemoComponent";

const Demo = () => {


    return (
        <Container maxWidth={false}>
            <DemoComponent/>
        </Container>
    );
};

export default Demo;